import React, { Component, Fragment } from 'react';
import $ from 'jquery';

class ProfileMenu extends Component {

    componentDidMount = () => {
        // menu config 
        var minSc = window.matchMedia("(min-width: 1200px)");
        if (minSc.matches) {
            document.getElementById("chck1").checked = true;
        } else {
            document.getElementById("chck1").checked = false;
        }

        // nav aktif
        document.getElementById("dosenNav").classList.add("active");
        document.getElementById("dosenOpen").classList.add("show");

        // konfig tabs menu profile-------------------------------------->
        // default tabs 
        $('#navRight .navRight-item:first').addClass('active');
        $('.tabsCon').addClass('hidden');
        $('.tabsCon:first').removeClass('hidden');
        // konfigurasi dengan klik event 
        $('#navRight .navRight-item').on("click", function () {
            // get id menu tabs 
            var aktifTab = $(this).attr('id');
            // aktif menu tabs 
            $('#navRight .navRight-item').removeClass('active');
            $(this).addClass('active');
            // konfigurasi tabs 
            $('.tabsCon').addClass('hidden');
            $('#' + aktifTab + 'box').removeClass('hidden');
        });
        // end konfig tabs menu profile ---------------------------------->
    }

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mt-4 mb-1 smoothTabs">
                    <div className="TapS" id="tabs">
                        <div className="tapbs">
                            <input type="checkbox" id="chck1" className="checkBox" />
                            <label className="tapbs-label" id="tabs-label" htmlFor="chck1">Profil</label>
                            <div className="tapbs-content">
                                <ul className="navRight" id="navRight">
                                    <li className="navRight-item" id="tab1">
                                        <a className="navRight-link" href="#">
                                            <i className="ti-user menu-icon" />
                                            <span className="menu-title">Biodata</span>
                                        </a>
                                    </li>
                                    <li className="navRight-item" id="tab2">
                                        <a className="navRight-link" href="#">
                                            <i className="ti-bag menu-icon" />
                                            <span className="menu-title">Posisi</span>
                                        </a>
                                    </li>
                                    <li className="navRight-item" id="tab3">
                                        <a className="navRight-link" href="#">
                                            <i className="ti-info-alt menu-icon" />
                                            <span className="menu-title">Info Lainnya</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <label className="footer-taps" id="tabs-label" htmlFor="chck1"></label>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default ProfileMenu;